import { useAuth } from '@clerk/nextjs'
import Link from 'next/link'
import { GrafbaseThemes } from 'style'

import { dashboardPaths } from 'domains/website/website.paths'
import { getDocsQuickStartPath } from 'lib/routes/replace-dynamic-paths'

import Box from 'components/atomic/atoms/box'
import Button from 'components/atomic/atoms/button'
import Text from 'components/atomic/atoms/text'

const SharedCta = ({
  title = 'Get Started',
  description = 'Build your API of the future now.',
}) => {
  const { isSignedIn } = useAuth()

  return (
    <Box
      relative
      css={{
        py: 50,
        width: '100%',
      }}
    >
      <Box css={{ container: 'md' }}>
        <Box
          flex={{ '@initial': 'column', '@sm': true }}
          items={{ '@initial': 'start', '@sm': 'center' }}
          justify={{ '@initial': 'start', '@sm': 'between' }}
          css={{
            container: 'lg',
            borderRadius: '$xl',
            padding: '$8',
            color: '#FDFCFD',
            border: '1px solid #8BE2CC',
            background:
              'linear-gradient(91deg, #FDFFFE 0%, #FAFFFD 50.5%, #F9FEFC 100%)',
            [`.${GrafbaseThemes.dark} &`]: {
              border: '1px solid #2A564C',
              background:
                'linear-gradient(91deg, #1A3A31 0%, #0D231D 52%, #13362E 100%)',
            },
          }}
        >
          <Box>
            <Text
              as="h2"
              weight="bold"
              size={{ '@initial': '2xl', '@sm': '3xl' }}
            >
              {title}
            </Text>
            <Box css={{ mt: '$2' }}>
              <Text as="p" size="md" color="text2">
                {description}
              </Text>
            </Box>
          </Box>
          <Box css={{ mt: '$4', '@sm': { mt: 'unset' } }}>
            <Link
              href={
                isSignedIn ? getDocsQuickStartPath() : dashboardPaths.register
              }
            >
              <Button variant="marketing" size="lg" css={{ fontSize: '$md' }}>
                Start Building
              </Button>
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default SharedCta
